import { AppContainer, TYPES } from "@/app/index";
import { Vue } from "vue-property-decorator";
import { EntityBase, EntityServiceBase } from '@/bases';
import { DataSet } from '@/models';
import { ConfigService } from '@/services';
import * as toastr from "toastr";

export class EntityListHelper<TService extends EntityServiceBase<TEntity>, TEntity extends EntityBase> {
  private VueComponent: Vue;
  public ConfigService: ConfigService = AppContainer.get<ConfigService>(TYPES.Services.ConfigService);
  public Service: TService;
  public DataSet: DataSet<TEntity>;
  public Fields: any;
  public CurrentRecord: TEntity = null;
  public AuditRecordId: string = null;

  private NewRecordFactory: () => TEntity

  constructor(vueComponent: Vue, service: TService, dataSet: DataSet<TEntity>, fields: any, newRecordFactory: () => TEntity) {
    this.VueComponent = vueComponent;
    this.Service = service;
    this.DataSet = dataSet;
    this.Fields = fields;
    this.CurrentRecord = null;
    this.AuditRecordId = null;
    this.NewRecordFactory = newRecordFactory;
  }

  public get EntityFormTitle() {
    return this.CurrentRecord && this.CurrentRecord.IsNew ? "New" : "Update";
  }

  public ShowEntityFormModal = (record: TEntity, index: any) => {
    this.CurrentRecord = this.NewRecordFactory();
    if (record) {
      Object.assign(this.CurrentRecord, record);
    }
    (this.VueComponent.$refs.entityFormModal as any).show();
  }

  public OnRecordSaved = () => {
    this.DataSet.Load();
    (this.VueComponent.$refs.entityFormModal as any).hide();
  }

  public OnRecordCancel = () => {
    (this.VueComponent.$refs.entityFormModal as any).hide();
  }

  public ViewRecordAudit = (recordId: string) => {
    this.AuditRecordId = recordId;
    (this.VueComponent.$refs.entityAuditModal as any).show();
  }

  public OnAuditClosed = () => {
    this.AuditRecordId = null;
  }

  public Delete(record: TEntity) {
    this.CurrentRecord = record;
    (this.VueComponent.$refs.confirmDeleteModal as any).show();
  }

  public ConfirmDelete() {
    this.Service.Remove(this.CurrentRecord.Id)
      .then((response) => {
        toastr.success("The record was deleted successfully.");
        this.DataSet.Load();
      })
      .catch((error) => {
        toastr.error("The record could not be deleted: " + error.response.data);
      });
  }
}